// test2665
(2665 && 0);
